import { Injectable } from '@angular/core';
import {
	HttpEvent,
	HttpInterceptor,
	HttpHandler,
	HttpRequest,
	HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SKIP_GLOBAL_ERROR } from '../errors/http-context-tokens';
import { GlobalApiErrorHandlerService } from '../errors/global-api-error-handler.service';

/**
 * Global HTTP error handler.
 *
 *  - When `SKIP_GLOBAL_ERROR` is set on the request context, the dialog is
 *    skipped and the original error is re-thrown for caller-side handling only.
 *  - Otherwise the error is mapped to an `IUiErrorMessage`, translated, shown
 *    in a notification dialog, and still re-thrown so callers can react.
 *
 * Translation chain for the message:
 *    1. translate `messageKey` (typically `ERRORS.<errorCode>`).
 *    2. fall back to ProblemDetails `detail` from the API.
 *    3. fall back to translated `ERRORS.GENERIC`.
 *    4. last resort: a hardcoded English message (so a missing catalog key
 *       never leaks the raw i18n key into the UI).
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly globalApiErrorHandlerService: GlobalApiErrorHandlerService
  ) { }
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError((error: HttpErrorResponse) => {
				this.globalApiErrorHandlerService.handle(error, req.context.get(SKIP_GLOBAL_ERROR));
				return throwError(() => error);
			})
		);
	}
}
